import React from 'react'
import '../assets/css/Table.css'
import '../assets/dmgAssets/css/UserSearch.css';
import Spinner from './Spinner';
import Input from '../DMGComponents/Input'
import Button from '../DMGComponents/Button'
import { searchUser, getAreaUsers, updateAreaUsers, updateWriteAccess, getAreaUsersForApproval } from '../fetchData';
import Break from '../DMGComponents/Break'
import Checkbox from '../DMGComponents/Checkbox'
import toast, { Toaster } from 'react-hot-toast';
import { withRouter } from 'react-router-dom';
import UserManagementIcon from '../assets/img/people-fill.svg';
import AddMultipleUsers from '../components/AddMultipleUsers'
import { AreaContext } from './AreaContext';
import { validateEmail } from '../utils/helperFunctions';

class UserManagement extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            searchText: "",
            searchUserResult: [],
            checked: [],
            isSearching: false,
            noResult: false,
            selectedUser: [],
            areaUsers: [],
            selectedAreaId: this.props.areaId,
            selectedAreaStatus: this.props.areaStatus,
            showMultiInput: false,
        }
        this.loadAreaUsers = this.loadAreaUsers.bind(this);
        this.openMultiInput = this.openMultiInput.bind(this);
        this.closeMultiInput = this.closeMultiInput.bind(this);
    }   

    componentDidMount() {
        this.loadAreaUsers(this.props.areaId);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.areaId !== this.props.areaId) {
            this.setState({ selectedAreaId: this.props.areaId });
            this.loadAreaUsers(this.props.areaId);
        }
    }

    openMultiInput = () => {
        this.setState({ showMultiInput: true });
    };

    closeMultiInput = () => {
        this.setState({ showMultiInput: false });
    };

    loadAreaUsers = (areaId) => {
        if (areaId != null) {
            this.setState({
                isSearching: true,
                areaUsers: []
            })
            if (this.props.isApprovalMode) {
                getAreaUsersForApproval(areaId).then((res) => {
                    this.fillUsers(res);
                }).catch((err) => {
                    console.error("Error", err)
                })
            }
            else {
                getAreaUsers(areaId).then((res) => {
                    this.fillUsers(res);
                }).catch((err) => {
                    console.error("Error", err)
                })
            }
        }
    }

    fillUsers = (res) => {
        const { setAreaUsersCount } = this.context;
        let arr = [];
        res.forEach(u => {
            arr.push({ email: u.email, firstName: u.firstName, lastName: u.lastName, company: u.company, extUserId: u.extUserId, userGuid: u.userGuid, owner: u.owner, permissionId: u.permissionId, writeAccess: u.writeAccess });
        });
        setAreaUsersCount(arr.length);
        this.setState({
            areaUsers: arr,
            isSearching: false
        });
    }

    addUser = (user = {}) => {
        var currUsers = this.state.areaUsers;
        var checkIfUserInList = currUsers.findIndex(object => {
            return object.email === user.email;
        });
        if (checkIfUserInList === -1) {
            currUsers.push(user);
            this.setState({
                areaUsers: currUsers
            }, this.updateUsers())
        }
    };

    removeUser = (user = {}) => {
        var currUsers = this.state.areaUsers;
        currUsers.splice(currUsers.findIndex(object => {
            return object.email === user.email;
        }), 1);
        this.setState({
            areaUsers: currUsers
        }, this.updateUsers())
    };

    saveSearch = () => {
        const { userSearchOnlyWithValidEmailAddressAllowed } = this.props;
        if (this.state.searchText.length > 0) {
            if (userSearchOnlyWithValidEmailAddressAllowed) {
                if (!validateEmail(this.state.searchText)) {
                    toast.error("Please enter a valid email address.");
                    return;
                }
            }
            this.setState({
                isSearching: true,
                searchUserResult: [],
                noResult: false
            })
        
            searchUser({ searchText: this.state.searchText }).then((res) => {
                let uArr = []
                res.forEach(e => {
                    uArr.push(e)
                });
                if (uArr.length == 0) {
                    this.setState({
                        searchUserResult: uArr,
                        isSearching: false,
                        noResult: true
                    })
                }
                this.setState({
                    searchUserResult: uArr,
                    isSearching: false
                })
            }).catch((err) => {
                console.error("Error", err);
            })
        }
    };

    updateUsers = () => {
        // check if owner is still in list --> if not show error
        if (this.state.areaUsers.length > 0) {
            updateAreaUsers(this.state.selectedAreaId, this.state.areaUsers).then(() => {
                toast.success("Updated users")
                this.loadAreaUsers(this.props.areaId);
            }).catch((err) => {
                toast.error("There was an error updating users");
                console.error("Error", err);
                this.loadAreaUsers(this.props.areaId);
            })
        }
    }

    addMultipleUsers = (usersToAdd) => {
        let newUsersToAdd = []
        let currUsers = this.state.areaUsers;
        for (let i = 0; i < usersToAdd.length; i++) {
            let checkIfUserInList = currUsers.findIndex(object => {
                return object.email === usersToAdd[i].email;
            });
            if (checkIfUserInList === -1) {
                newUsersToAdd.push(usersToAdd[i]);
            }
        }
        let updatedUsers = currUsers.concat(newUsersToAdd);
        if (updatedUsers.length > 0) {
            updateAreaUsers(this.state.selectedAreaId, updatedUsers).then(() => {
                toast.success("Updated users")
                this.loadAreaUsers(this.props.areaId);
            }).catch((err) => {
                toast.error("There was an error updating users");
                console.error("Error", err);
                this.loadAreaUsers(this.props.areaId);
            })
        }
    };

    writeAccessPermission = (user) => {
        user.writeAccess = !user.writeAccess;
        updateWriteAccess(this.state.selectedAreaId, user).then(() => {
            toast.success("Updated write access");
            this.loadAreaUsers();
        }).catch((err) => {
            console.error("Error", err);
        })
    };

    generateTableBodySelected = (array) => {
        return array.map((item, index) => {
            return (
                <tr key={index} className="searchContent">
                    <td >
                        <Checkbox style={{ marginLeft: 15 }} checked={item.owner} disabled={true} />
                    </td>
                    <td >
                        <Checkbox style={{ marginLeft: 15 }} checked={item.writeAccess} disabled={item.owner || this.props.isApprovalMode} onClick={() => { this.writeAccessPermission(item) }} />
                    </td>
                    <td >
                        {item.email}
                    </td>
                    <td hidden={false}>
                        {item.firstName}
                    </td>
                    <td hidden={false}>
                        {item.lastName}
                    </td>
                    <td hidden={false}>
                        {item.company}
                    </td>
                    {!item.owner && !this.props.isApprovalMode && <td ><Button type="hover-bottom-left" onClick={() => { this.removeUser(item) }}>Remove</Button></td>}
                    {(item.owner || this.props.isApprovalMode) && <td></td>}
                </tr>
            )
        })
    }

    generateTableBody = (array) => {
        return array.map((item, index) => {
            return (
                <tr key={index} className="searchContent" style={item.isBlacklisted ? { color: '#c00' } : {}}>
                    <td>
                        {item.email}
                        {item.isBlacklisted && <span style={{ marginLeft: 6, fontSize: '0.8em', fontWeight: 'bold' }}> (blacklisted)</span>}
                    </td>
                    <td hidden={false}>
                        {item.firstName}
                    </td>
                    <td hidden={false}>
                        {item.lastName}
                    </td>
                    <td hidden={false}>
                        {item.company}
                    </td>
                    <td hidden={false}>
                        {item.isBlacklisted
                            ? <span style={{ color: '#c00', fontSize: '0.85em' }}>Cannot add</span>
                            : <Button type="hover-bottom-left" onClick={() => { this.addUser(item) }}>Add</Button>
                        }
                    </td>

                </tr>
            )
        })
    }

    render() {
        return (
            <div style={{ ...this.props.style, textAlign: "left" }} className="fileExChildComponent">
                <Toaster />
                <AddMultipleUsers show={this.state.showMultiInput} handleClose={this.closeMultiInput} areaId={this.state.selectedAreaId} currentUsers={this.state.areaUsers} addMultipleUsers={this.addMultipleUsers} />
                <Break style={{ margin: "20px 0" }}>
                    <div style={{ display: "flex" }}>
                        <div style={{ marginRight: "44px" }}>
                            <img
                                src={UserManagementIcon}
                                alt="Area Content"
                                style={{ height: "2rem", position: "absolute" }}
                            />
                        </div>
                        <div>
                            User Management
                        </div>
                    </div>
                </Break>
                {this.state.areaUsers.length > 0 &&
                    <div>
                        <table style={{ width: "100%" }}>
                            <thead>
                                <tr>
                                    <th style={{ width: "30px", textAlign: "center" }}>Owner</th>
                                    <th style={{ width: "30px", textAlign: "center" }}>Write Access</th>
                                    <th >Email</th>
                                    <th >Firstname</th>
                                    <th >Lastname</th>
                                    <th >Company</th>
                                    <th style={{ width: "30px", textAlign: "center" }}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.generateTableBodySelected(this.state.areaUsers)}
                            </tbody>
                        </table>
                        <hr style={{ margin: "30px 0" }} />
                    </div>
                }
                {!this.props.isApprovalMode &&
                    <React.Fragment>
                        <div onKeyPress={e => e.key == 'Enter' && this.state.searchText.length > 3 && this.saveSearch()}>
                            <Input label={
                                this.props.userSearchOnlyWithValidEmailAddressAllowed
                                    ? (this.state.searchText.length > 0 ? "Enter a valid email address" : "Search user to add")
                                    : (this.state.searchText.length < 4 && this.state.searchText.length > 0 ? "Enter at least 4 characters" : "Search user to add")
                            } value={this.state.searchText} onClick={e => { this.setState({ searchText: e }) }} />
                        </div>
                        <div style={{ marginTop: "8px" }}>
                            {this.state.selectedAreaStatus === 1 && !this.props.managerApprovalRequired &&
                                <p>A notification will be sent to users immediately after adding them.</p>
                            }
                            {this.state.selectedAreaStatus === 1 && this.props.managerApprovalRequired &&
                                <p>A notification will be sent to users and your manager immediately after adding them.</p>
                            }
                            {this.state.selectedAreaStatus === 0 && !this.props.managerApprovalRequired &&
                                <p>Notifications will be sent after the area is released.</p>
                            }
                            {this.state.selectedAreaStatus === 0 && this.props.managerApprovalRequired &&
                                <p>Notifications will be sent after the area is approved.</p>
                            }
                        </div>
                        <div style={{ display: "flex", justifyContent: "right", marginBottom: "12px", marginTop: '8px' }}>
                            <div style={{ marginRight: "12px" }}>
                                <Button type="hover-bottom-left" onClick={() => { this.openMultiInput() }}>Add multiple users</Button>
                            </div>
                            <div style={{ marginRight: "12px" }}>
                                <Button type="hover-bottom-left"
                                    onClick={() => this.props.history.push({
                                        pathname: '/createUser',
                                        state: {
                                            areaId: this.state.selectedAreaId
                                        }
                                    })}>Create New User</Button>
                            </div>
                            <div>
                                <Button type="hover-bottom-left"
                                    onClick={() => { this.saveSearch() }}
                                    disabled={
                                        this.props.userSearchOnlyWithValidEmailAddressAllowed
                                            ? !validateEmail(this.state.searchText)
                                            : this.state.searchText.length < 4
                                    }
                                >
                                    Search
                                </Button>
                            </div>
                        </div>
                        {this.state.searchUserResult.length == 0 && this.state.isSearching &&
                            <><div style={{ textAlign: "center" }}>
                                <Spinner />
                            </div></>
                        }
                        {this.state.searchUserResult.length == 0 && this.state.noResult &&
                            <p style={{ fontSize: "22px" }}>No user found</p>
                        }
                        {this.state.searchUserResult.length > 0 &&
                            <table style={{ width: "100%" }}>
                                <thead>
                                    <tr>
                                        <th >Email</th>
                                        <th >Firstname</th>
                                        <th >Lastname</th>
                                        <th >Company</th>
                                        <th style={{ width: "30px", textAlign: "center" }}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.generateTableBody(this.state.searchUserResult)}
                                </tbody>
                            </table>
                        }
                        <hr style={{ margin: "30px 0" }} />
                    </React.Fragment>
                }
            </div>

        );
    }
}
export default withRouter(UserManagement);
UserManagement.contextType = AreaContext